import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { widgetTypeState } from '../../states';
import { ModalStyles } from './Styles';

type AddBiometryModalProps = {
  show?: boolean;
  onChangeShow(show: boolean): void;
  onAddBiometry(): void;
};

export const AddBiometryModal = ({
  show,
  onChangeShow,
  onAddBiometry,
}: AddBiometryModalProps) => {
  const { t } = useTranslation();
  const widgetType = useRecoilValue(widgetTypeState);
  return (
    <ModalStyles
      show={show}
      onChangeShow={onChangeShow}
      header={{
        title: t('Add method as a security biometric?', {
          widgetType: t(widgetType as string, { context: 'capital' }),
        }) as string,
      }}
      footer={{
        onSubmitButton: () => onAddBiometry(),
        onCloseButton: () => onChangeShow(false),
        closeButtonLabel: t('Cancel') as string,
        submitButtonLabel: t('Add') as string,
      }}
      hasPadding
      disableOnClickOutside
    >
      <Label>
        {t('You will be able to verify your identity through your method', {
          widgetType: t(widgetType as string),
        })}
      </Label>
    </ModalStyles>
  );
};
